import { ChatMessage } from "./ChatMessagesList";
import moment from "moment";
import ChatMessageBubble from "./ChatMessageBubble";

type ChatMessagesGroup = {
  messages: ChatMessage[];
  date: string;
};

export default function ChatMessagesGroup(props: ChatMessagesGroup) {
  const { messages, date } = props;

  return (
    <>
      <div className="relative py-3.5">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-b border-gray-300"></div>
        </div>
        <div className="relative flex justify-center">
          <span className="bg-white px-4 text-sm text-gray-400">
            {moment(date).format("dddd D/M/YYYY")}
          </span>
        </div>
      </div>
      {messages.map((message, index) => {
        return (
          <ChatMessageBubble
            message={message}
            key={`${message.message}-${index}`}
          />
        );
      })}
    </>
  );
}
